// How much of the window the page's bars cover, for deck/camera.js (camera.setInsets): the top pills (and the
// 会议室's small floating window under them), the bottom bar with the chat log's head and the chat box above it (the
// log opened grows up from the bar, its head with it), and the safe areas (notch, home bar). The view keeps
// my otter, and lets the map's edges come, inside what's left. Except the pills, a bar counts only where it crosses the
// middle third of the window's width (the chat log in a desktop's corner doesn't); a top one covers from the top down to its bottom
// edge, a bottom one from its top edge down. Measured when any of them changes size, on resize, and once a second
// (they also move and show or hide without changing size). CSS px.
const TOP = ['#topleft > :not(#onlineList)', '#meetMini'], BOTTOM = ['.bar', '#chathead', '#chatbox'], BARS = [...TOP, ...BOTTOM];
const SAFE_PROBE = 'position:fixed;left:0;top:0;width:0;height:0;visibility:hidden;pointer-events:none;padding:var(--st,0px) var(--sr,0px) var(--sb,0px) var(--sl,0px)';
const GAP = 4; // px between a bar and the view's open area

/** The covered insets {top, right, bottom, left} now. */
export function hudInsets(doc = document) {
  const W = innerWidth, H = innerHeight, probe = doc.getElementById('hudSafeProbe');
  const cs = probe && getComputedStyle(probe), px = (v) => parseFloat(v) || 0;
  const ins = { top: px(cs?.paddingTop), right: px(cs?.paddingRight), bottom: px(cs?.paddingBottom), left: px(cs?.paddingLeft) };
  for (const sel of BARS) {
    for (const el of doc.querySelectorAll(sel)) {
      const r = el.getBoundingClientRect();
      const top = TOP.includes(sel), band = sel !== TOP[0]; // (the pills count wherever they are)
      if (!r.width || !r.height || (band && (r.right < W / 3 || r.left > (W * 2) / 3)) || r.bottom <= 0 || r.top >= H) continue;
      if (getComputedStyle(el).visibility === 'hidden') continue;
      if (top) ins.top = Math.max(ins.top, r.bottom + GAP);
      else ins.bottom = Math.max(ins.bottom, H - r.top + GAP);
    }
  }
  return ins;
}

/** Keep camera's insets up to date with the page. */
export function watchHud(camera, doc = document) {
  if (!doc.getElementById('hudSafeProbe')) {
    const p = Object.assign(doc.createElement('div'), { id: 'hudSafeProbe' }); p.style.cssText = SAFE_PROBE; doc.body.append(p);
  }
  const put = () => camera.setInsets(hudInsets(doc));
  const ro = window.ResizeObserver ? new ResizeObserver(put) : null, seen = new WeakSet();
  const observe = () => { for (const sel of BARS) for (const el of doc.querySelectorAll(sel)) if (!seen.has(el)) { seen.add(el); ro?.observe(el); } };
  observe(); put();
  addEventListener('resize', () => { put(); setTimeout(put, 300); }); // (iOS reports a turned phone's size late)
  setInterval(() => { observe(); put(); }, 1000); // (bars made later, moved, shown or hidden)
}
